<template lang="pug">
  .events
    GenericTable(ref="grid" :loading="loading")
      tr(slot="thead")
        th Code
        th Business Step
        th Disposition
        th Event Time
        th User
        th Package
        th Product
      tr(v-for="e in events")
        td.kzcode-default.clickable(@click="traceCode(e.package.code)") {{e.package.code}}
        td {{e.bizStep | bizStep}}
        td {{e.disposition | disposition}}
        td {{e.eventTime | date}}
        td {{e.user.username}}
        td {{e.package.packageType.name}}
        td {{e.product}}
    IndefinitePagination(:fetch="fetchData")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import IndefinitePagination from '@/components/common/IndefinitePagination'
import TrackNTrace from '@/service/apis/TrackNTrace'
import { dateFilter } from '@/filters/filters'
import { bizStepFilter, dispositionFilter } from '@/components/pages/trackntrace/utils'

export default {
  data: () => ({
    loading: false,
    events: null,
    page: {
      offset: 0,
      hasMore: false
    }
  }),
  methods: {
    fetchData(req) {
      this.loading = true
      return TrackNTrace.getLocationEvents(this.locationId, req)
        .then((resp) => {
          this.events = resp.data.event
          this.loading = false
          return resp.data.hasMore
        })
        .catch((e) => { this.$emit('error', e) })
    },
    traceCode(code) {
      this.$router.push({ name: 'traceDetails', params: { code } })
    }
  },
  computed: {
    locationId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    GenericTable,
    IndefinitePagination
  },
  filters: {
    date: dateFilter,
    disposition: dispositionFilter,
    bizStep: bizStepFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/Events.vue